import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Linkedin } from "lucide-react";
import { NAV_LINKS, CONTACT_INFO } from "../data/mock";
import LogoMark from "./LogoMark";

const Footer = () => {
  return (
    <footer className="grain bg-[#0d1526] text-white pt-20 pb-8">
      <div className="max-w-[1280px] mx-auto px-6 md:px-8">
        {/* big statement */}
        <div className="mb-16">
          <h2 className="font-serif text-[46px] md:text-[68px] leading-[0.98] font-semibold">
            Finding Talent.
            <br />
            <span className="italic text-[var(--gold)]">Driving Success.</span>
          </h2>
        </div>

        <div className="h-px w-full bg-white/10 mb-14" />

        <div className="grid md:grid-cols-3 gap-12">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <LogoMark size={40} className="shrink-0" />
              <span className="font-serif text-lg font-bold">PT Hiring Solutions</span>
            </div>
            <p className="text-white/55 text-sm leading-relaxed max-w-xs">
              A specialist recruitment partner for IT and Non-IT hiring — from promising junior talent to transformative C-suite leadership.
            </p>
          </div>

          <div>
            <div className="eyebrow mb-5">Sitemap</div>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.path}>
                  <Link to={l.path} className="text-white/65 hover:text-[var(--gold)] transition-colors text-sm">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="eyebrow mb-5">Contact</div>
            <ul className="space-y-4 text-sm">
              <li className="flex items-center gap-3 text-white/65">
                <Mail size={16} className="text-[var(--gold)] shrink-0" />
                <a href={`mailto:${CONTACT_INFO.email}`} className="hover:text-white transition-colors break-all">
                  {CONTACT_INFO.email}
                </a>
              </li>
              <li className="flex items-center gap-3 text-white/65">
                <Phone size={16} className="text-[var(--gold)] shrink-0" />
                <a href={`tel:${CONTACT_INFO.phoneHref}`} className="hover:text-white transition-colors">
                  {CONTACT_INFO.phone}
                </a>
              </li>
              <li className="flex items-center gap-3 text-white/65">
                <MapPin size={16} className="text-[var(--gold)] shrink-0" />
                {CONTACT_INFO.location}
              </li>
              <li className="flex items-center gap-3 text-white/65">
                <Linkedin size={16} className="text-[var(--gold)] shrink-0" />
                <a
                  href={CONTACT_INFO.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                >
                  LinkedIn
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="h-px w-full bg-white/10 mt-16 mb-6" />
        <div className="flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-white/40">
          <span>© 2026 PT Hiring Solutions. All rights reserved.</span>
          <span className="tracking-[0.2em] uppercase">Founded by Preeti Thakur</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
